export default __webpack_public_path__ + "static/media/Icon_favourites.b260d596.svg";